import { render, staticRenderFns } from "./SfSection.vue?vue&type=template&id=5fe8688c&"
import script from "./SfSection.vue?vue&type=script&lang=js&"
export * from "./SfSection.vue?vue&type=script&lang=js&"
import style0 from "./SfSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports